export const breakpoints = {
  mobile: '485px',
  smallTablet: '750px',
  mediumTablet: '950px',
  large: '1200px',
  extraLarge: '1400px',
} as const;

type breakpointsType = typeof breakpoints;
type keys = keyof breakpointsType;

export const device = Object.keys(breakpoints).reduce(
  (obj, breakpoint) => ({ ...obj, [breakpoint]: `@media (min-width: ${breakpoints[breakpoint as keys]})` }),
  {},
) as breakpointsType;
